module.exports = __webpack_public_path__ + "static/img/7.adb4593.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/7.png
// module id = 3WcI
// module chunks = 0